<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/vue'

import { storeToRefs } from 'pinia'
import RectangleSizePart from '@/components/SizeAndButtons/RectangleSizePart.vue'
import CircleSizePart from '@/components/SizeAndButtons/CircleSizePart.vue'
import ButtonsStitchesWithQtyPart from '@/components/SizeAndButtons/ButtonsStitchesWithQtyPart.vue'
import ButtonsStitchesNoQtyPart from '@/components/SizeAndButtons/ButtonsStitchesNoQtyPart.vue'
import { useStore } from '@/stores/store'
import { IconChevronDown } from '@/components/icons'
import { useElements } from '@/stores/elements'

const store = useStore()

const { thickness, cushion, shape } = storeToRefs(store)
const elementsStore = useElements()
const { elements } = storeToRefs(elementsStore)
const isNotFlat = computed(() => cushion.value !== 'flat_cushion')
const allThickness = ref([
  { text: '3', value: 3 },
  { text: '5', value: 5 },
  { text: '7', value: 7 },
  { text: '10', value: 10 },
])
const flatThickness = [{ text: '5', value: 5 }]

const sizeComponent = computed(() =>
  store.isCircle ? CircleSizePart : shape.value === 'rectangle' ? RectangleSizePart : null,
)
const buttonsStitchesComponent = computed(() =>
  store.isCircle
    ? ButtonsStitchesNoQtyPart
    : shape.value === 'rectangle'
      ? ButtonsStitchesWithQtyPart
      : null,
)

onMounted(() => {
  if (import.meta.env.PROD) {
    allThickness.value = []

    const Elements = elements.value

    for (let i = 0; i < Elements.thickness.length; i++) {
      const text = document.querySelector(
        '#' + Elements.thickness[i].id + ' +label span',
      )!.innerHTML
      allThickness.value.push({
        text: text,
        value: parseInt(text),
      })
    }
  }
  thickness.value = !isNotFlat.value ? 5 : thickness.value ? thickness.value : 3
})
</script>
<template>
  <div class="form-block-wrapper w-full">
    <div class="form-wrapper">
      <div class="third-page-form">
        <div class="form-part space-y-6 lg:space-y-10">
          <component :is="sizeComponent" />

          <div class="form-group full-row">
            <label class="field-label">{{ $t('Thickness') }}</label>
            <Listbox v-model="thickness">
              <div class="relative mt-1">
                <ListboxButton
                  class="relative w-full select inline-flex justify-between items-center py-4 px-6 text-left bg-white border border-black"
                >
                  <span>{{ thickness + ' cm' }}</span>
                  <IconChevronDown class="chevron transition-all duration-300" />
                </ListboxButton>
                <ListboxOptions
                  class="absolute z-10 mt-1 w-full bg-white border rounded-md shadow-lg"
                >
                  <ListboxOption
                    class="cursor-pointer px-4 py-2"
                    v-for="thicknessItem in isNotFlat ? allThickness : flatThickness"
                    :key="thicknessItem.value"
                    :value="thicknessItem.value"
                    >{{ thicknessItem.text + ' cm' }}</ListboxOption
                  >
                </ListboxOptions>
              </div>
            </Listbox>
          </div>
          <component :is="buttonsStitchesComponent" />
        </div>
      </div>
    </div>
    <div style="display: none">
      <canvas id="2d-cushion-render" />
    </div>
  </div>
</template>

<style scoped></style>
